import { Navigate, Route, Routes } from 'react-router-dom';

// components
import PageNotFound from './pages/PageNotFound';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import DefaultLayout from './layouts/DefaultLayout';
import ProjectManagement from './pages/ProjectManagement';
import Setup from './pages/Setup';
import Prompt from './pages/Prompt';
import Template from './pages/Template';
import PromptDetail from './pages/PromptDetail';
import TemplateDetail from './pages/TemplateDetail';
import ElaborationDetail from './pages/ElaborationDetail';
import KnowledgeBase from './pages/KnowledgeBase';
import KnowledgeBaseDetail from './pages/KnowledgeBaseDetail';
import Projects from './pages/Projects';
import NewElaboration from './pages/NewElaboration';
import ElaborationList from './pages/ElaborationList';

//api
import AuthenticationService from './service/authentication-service';



const routes = () => {
    const isLoggedIn = AuthenticationService.isLoggedIn();

    return (
        <Routes>
            <Route exact path="/" 
            element={ isLoggedIn ? <Navigate to="/dashboard/home" replace /> : <Navigate to="/login" replace />}/>
            <Route exact path="/login" element={<Login/>}/>
            <Route exact path="/dashboard/" element={<Navigate to="/dashboard/home" replace />} />
            <Route path="/dashboard/*" element={<ProtectedRoute/>} > 
                <Route path="" element={<DefaultLayout/>}>
                    <Route path='home' element={<Dashboard/>}/>
                    <Route path="projects" element={<Projects/>}/>
                    <Route path="project_management/:id" element={<ProjectManagement/>}/>
                    <Route path="setup" element={<Setup/>}/>
                    <Route path="prompt" element={<Prompt/>}/>
                    <Route path="prompt/:id" element={<PromptDetail/>}/>
                    <Route path="template" element={<Template/>}/>
                    <Route path="template/:id" element={<TemplateDetail/>}/>
                    <Route path='list_elaboration' element={<ElaborationList/>}/>
                    <Route path='new_elaboration' element={<NewElaboration/>}/>
                    <Route path='elaborations/:id' element={<ElaborationDetail/>} />
                    <Route path='kb' element={<KnowledgeBase/>}/>
                    <Route path='kb/:id' element={<KnowledgeBaseDetail/>} />
                </Route>
            </Route>
            
            <Route path="*" element={<PageNotFound/>}/>
        </Routes>)
};

export default routes;
